export enum LocationDataCodes {
  Success = 0,
  DeniedPermissions = 1,
  InvalidLocationData = 2,
}

export type LocationData = {
  code: number | string
  domain: string
  heading: string
  latitude: string
  locCount: string
  longitude: string
  message: string
  receivedTimestamp: number
  speed: string
  submitterIpAddress: string
  timeStamp: string
}

export type LocationSmartResponse = {
  locationData: LocationData
  requestTime: string
  sessionId: string
  statusCode: string
  statusMsg: 'Error' | 'Success'
  uid: string
}
